var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0",attrs:{"id":"subscription","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"10","lg":"9"}},[_c(_vm.currentComponent,{tag:"component",attrs:{"id":_vm.currentComponent},on:{"back":_vm.onBack,"next":_vm.onNext}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }